import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';

export function getPmDoc(api: ExtractInjectionAPI<AIPlugin> | undefined) {
	let doc: PMNode | undefined;
	// Quick and dirty way to get the doc
	api?.core.actions.execute(({ tr }) => {
		doc = tr.doc;
		return null;
	});
	return doc;
}
